import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {configCategoriesView_template} from "../components/templates/configCategoriesView_template";

declare var ko: any;
declare var page: any;

export class config_categories_view extends vnModule_knockoutJS{

    protected viewForm: configCategoriesView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return "config_categories_view";
    }

    buildContent(): Array<Element>{

        this.viewForm = new configCategoriesView_template("view_template", this.viewModel, this);
        return [this.viewForm.build()];
    }

    public fillPage(): void{

        this.getCategory();
    }

    protected getCategory(){

        this.loadingIn(this.viewForm.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idCategory = this.getVnAppZone().getApp().params.idCategory;

        let usrReq_url: string = '/api/brand/' + idBrand + "/categories/get/"+idCategory;

        let usrReq_params: Array<Array<string>> = [];

        let vm = this.viewForm.getViewModelForRequest();

        usrReq_params.push(["data", ko.toJSON(vm)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.setCategory(responseParsed.data);
            });

            obj.loadingOut(obj.viewForm.builtTemplate);
        }
    }

    public setCategory(data): void{

        this.viewForm.setId(data.category.id);
        this.viewForm.setName(data.category.name);
        this.viewForm.setPinnedTags(data.pinnedTags);

        if(data.category.details){

            this.viewForm.setSlug(data.category.details.slug);
            this.viewForm.setDescription(data.category.details.description);
            this.viewForm.setIsSelectable(data.category.details.isSelectable ? true : false);
            this.viewForm.setDateCreated(data.category.details.dateCreated.substring(0,10));
            this.viewForm.setImage(data.category.details.image);
            this.viewForm.setIcon(data.category.details.iconImage);
        }
        else {
            this.viewForm.setIsSelectable(false);
        }

    }

    protected edit(id){

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect('/brand/' + idBrand + "/categorization/categories/edit/" + id);

    }

    protected cancel(){

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect('/brand/' + idBrand + "/categorization/categories");
    }


}


// WEBPACK FOOTER //
// ./js/modules/config_categories_view.ts